/** Existing Queue filters, shared by paged reads and live additions. */
export function applyTimelineFilters(events, filters = {}) {
  let filtered = events;

  // Filter by event type (including specific consequence types)
  if (filters.eventType) {
    filtered = filtered.filter(event => {
      // Direct match on type field
      if (event.type === filters.eventType) return true;

      // For consequence events, also check consequenceType field
      if (event.consequenceType === filters.eventType) return true;

      // For legacy data, check value field if event type is 'consequence'
      if (event.type === 'consequence' && event.originalData?.value === filters.eventType) return true;

      return false;
    });
  }

  // Filter by status
  if (filters.status) {
    filtered = filtered.filter(event => event.status === filters.status);
  }

  // Filter by search query
  if (filters.searchQuery?.trim()) {
    const query = filters.searchQuery.toLowerCase();
    filtered = filtered.filter(event =>
      event.studentName?.toLowerCase().includes(query) ||
      event.offence?.toLowerCase().includes(query) ||
      event.notes?.toLowerCase().includes(query)
    );
  }

  // Filter by date range
  if (filters.startDate) {
    const startDate = new Date(filters.startDate);
    filtered = filtered.filter(event => event.timestamp >= startDate);
  }

  if (filters.endDate) {
    const endDate = new Date(filters.endDate);
    endDate.setHours(23, 59, 59, 999); // Include full end date
    filtered = filtered.filter(event => event.timestamp <= endDate);
  }

  // Filter by severity
  if (filters.severity) {
    filtered = filtered.filter(event => event.severity === filters.severity);
  }

  return filtered;
}
